import Indicator, { IndicatorType } from '../types/Indicator'

const MovingAverageEnvelope: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'movingAverageEnvelope',
  label: 'Moving Average Envelope',
  nickname: 'Moving Average Envelope',
  fields: ['middle', 'upper', 'lower'],
  params: {
    period: 20,
    field: 'close',
    multiplier: 0.1,
    multiplierType: 'percent',
    movingAverageType: 'simple',
  },
}

export default MovingAverageEnvelope
